const Classes = () => {
    return ( 
        <div className="classes flex flex-fd-c flex-jc-s  flex-ai-c default-pad">
            <div className="starter flex flex-fd-c flex-jc-sa flex-ai-c">
            <h2>Beginner</h2>
                <img src="https://images.pexels.com/photos/864939/pexels-photo-864939.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="" />
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Neque laborum sapiente quidem dolorum voluptates repellat!</p>
                <ul>
                    <li>Professional Instructor</li>
                    <li>2x times a week</li>
                    <li>45 min sessions</li>
                    <li>8 member classes</li>
                    <li>Equipment provided</li>
                </ul>
                <a href="" className="button">Book Now</a>
            </div>
            <div className="intermediate flex flex-fd-c flex-jc-sa flex-ai-c">
            <h2>Intermediate</h2>
            <img src="https://images.pexels.com/photos/8436581/pexels-photo-8436581.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="" />
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Neque laborum sapiente quidem dolorum voluptates repellat!</p>
                <ul>
                    <li>Professional Instructor</li>
                    <li>3x times a week</li>
                    <li>50 min sessions</li>
                    <li>6 member classes</li>
                    <li>Equipment provided</li>
                </ul>
                <a href="" className="button">Book Now</a>
            </div>
            <div className="private flex flex-fd-c flex-jc-sa flex-ai-c">
            <h2>Private</h2>
            <img src="https://images.pexels.com/photos/3900798/pexels-photo-3900798.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="" />
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Neque laborum sapiente quidem dolorum voluptates repellat!</p>
                <ul>
                    <li>Professional private Instructor</li>
                    <li>4x times a week</li>
                    <li>1 hour sessions</li>
                    <li>Open air classes</li>
                    <li>Equipment provided</li>
                </ul>
                <a href="" className="button">Book Now</a>
            </div>
        </div>
     );
}
 
export default Classes;